module.exports = __webpack_public_path__ + "img/google-play-id.2c2ab5a7.png";